import React from 'react'

const HomePage = () => {
  return (
    <div>Consumer HomePage</div>
  )
}

export default HomePage